import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ExclamationTriangle = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7 17.4999L14.6 3.49986C13.8 2.09986 11.9 1.59987 10.5 2.39987C10 2.69987 9.6 3.09986 9.4 3.49986L1.3 17.4999C0.499996 18.8999 0.999996 20.7999 2.4 21.5999C2.9 21.8999 3.4 21.9999 3.9 21.9999H20C21.7 21.9999 23 20.5999 23 18.9999C23.1 18.3999 22.9 17.8999 22.7 17.4999ZM12 17.9999C11.4 17.9999 11 17.5999 11 16.9999C11 16.3999 11.4 15.9999 12 15.9999C12.6 15.9999 13 16.3999 13 16.9999C13 17.5999 12.6 17.9999 12 17.9999ZM13 12.9999C13 13.5999 12.6 13.9999 12 13.9999C11.4 13.9999 11 13.5999 11 12.9999V8.99987C11 8.39987 11.4 7.99987 12 7.99987C12.6 7.99987 13 8.39987 13 8.99987V12.9999Z"
      fill="currentColor"
    />
  </svg>
)

export default ExclamationTriangle
